<template>
  <div>
    <el-select
      v-model="value"
      placeholder="Tipo"
      @change="OnTypeChange"
      size="mini"
      clearable
      :disabled="disabled"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "TypeTasks",
  props: {
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      // Define your component's data properties here
      value: "",
      options: [
        // { value: null, label: "Todos" },
        { value: "SI", label: "Solicitudes Internas" },
        { value: "SE", label: "Solicitudes Externas" },
        { value: "TE", label: "Tareas Estratégicas" },
        { value: "TO", label: "Tareas Operacionales" }
      ]
    };
  },
  methods: {
    OnTypeChange(value) {
      this.value = value;
      this.$emit("type-change", value);
    }
  }
};
</script>

<style></style>
